define('app/sf/title/case/ignore/sf-title-case-ignore-factory',[],function () {
	"use strict";
	var englishArticles = ["a", "an", "the", "and", "but", "or", "for", "nor", "on", "at", "to", "from", "by"];
	return sfTitleCaseIgnoreFactory;
	function sfTitleCaseIgnoreFactory(word) {
		return englishArticles.indexOf(word) >= 0;
	}
});
